import React from 'react'
import Flickity from 'react-flickity-component'
import 'flickity/css/flickity.css'
import './ImageSlider.css'
import { getImageSrcset, getImageSrc } from '../util/getImageUrl'

const Image = ({image, alt}) =>
  <img className='ImageSlider--slide'
    key={`image-${image}`}
    src={getImageSrc(image, 300)}
    srcSet={getImageSrcset(image)}
    sizes='(min-width: 750px) 50vw, 100vw'
    alt={alt}
  />

export default ({images, alt}) => {
  const flickityOptions = {
    autoPlay: 6000,
    pageDots: true,
    prevNextButtons: false
  }
  return (
    images.length > 1 ? (
      <Flickity
        className={'ImageSlider'}
        options={flickityOptions}
        disableImagesLoaded={false}
        reloadOnUpdate
      >
        {images.map(image => <Image key={`image-${image}`} image={image} alt={alt} />)}
      </Flickity>
    ) : <Image image={images[0]} alt={alt} />
  )
}



// WEBPACK FOOTER //
// ./src/ImageSlider/index.js